import { render, staticRenderFns } from "./store-cart.vue?vue&type=template&id=231ff8c0"
import script from "./store-cart.vue?vue&type=script&lang=js"
export * from "./store-cart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports